import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';

import MessageSection from '../../web/components/MessageSection';
import { MenuItem } from '../../web/components/styled';
import Box from '../Main/pages/Overview/Box';

export default class Signup extends Component {
	componentDidMount() {
		/* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Contract Next button Click');
	}
	render () {
		return (
			<Container>
				<Helmet
					title="Signup"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<div style={{ display: 'flex', flexDirection: 'column', height: '100%', marginTop: 25 }}>
					<MessageSection
						style={{ marginTop: '50px' }}
						header="Your registration is complete"
						paragraph1="So now that you’ve signed the agreement, what’s next?"
					/>
				</div>
				<div style={{ display: 'flex', flexDirection: 'row', height: '100%', justifyContent: 'center', marginTop: 25 }}>
					<Section>
						{/* <Box
							src="/images/redesign/icon-contract.png"
							text="You will receive a signed copy of your contract by email."
							width="40px"
						/> */}
						<Box
							src="/images/redesign/icon-email.png"
							// text="This email will contain all training materials for blueshyft services."
							text="You will receive an email containing all training materials for blueshyft."
							width="50px"
						/>
						<Box
							src="/images/redesign/icon-package.png"
							text="You will then receive your hardware by post, with all equipment inside!"
							width="50px"
						/>
					</Section>
				</div>
				<div style={{ display: 'flex', flexDirection: 'row', height: '100%', justifyContent: 'center', marginTop: 0 }}>
					<MainSection>
						<Text>To prepare for customers, please review training materials you have just received by email, but if you ever need a hand you can reach us on 1800 817 483 or at support@blueshyft.com.au.</Text>
						<Text>Welcome to the network - we look forward to working with you!</Text>
					</MainSection>
				</div>
			</Container>
		);
	}
};

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;

const Section = styled.div`
  width: 565px;
  height: 150px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding-left: 50px;
  padding-right: 50px;
`;

const MainSection = styled.div`
  width: 965px;
  height: 175px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 50px;
	color: #505d68;
  margin-bottom: 25px;
`;

const Text = styled.div`
  font-family: 'Karla', sans-serif;
  font-size: 20px;
	color: #505D68;
	text-align: center;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Complete/index.js